import src from "../../../assets/login-artwork-right.svg";
import { Asset } from "../Asset";

export const LoginArtworkRight = Asset(src);
